module.exports = __webpack_public_path__ + "Poppins-ExtraLight.cc5f98871935873dc78a.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraLight.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraLight.woff
// module chunks = styles